<template>
	<template-base class="containerCard">
		<div>
			<div v-if="categoryExpenses.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + categoryExpenses.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
			<EditCategoryExpenses
				v-if="modalEdit"
				:categoryExpenseData="categoryExpenseSelected"
				@closeModal="closeModal"
				@findCategoryExpenses="findCategoryExpenses"
			/>
		</div>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nofilters="true"
				name="categoriaContas"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CATEGORIAS')"
				:permissaoDelete="possuiPermissao('GER_D_CATEGORIAS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_CATEGORIAS')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CATEGORIAS')"
				:permissaoDelete="possuiPermissao('GER_D_CATEGORIAS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_CATEGORIAS')"
			/>
		</div>
		<div v-if="categoryExpenses.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { CategoryExpensesService } from "../../services/categoryExpenses";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import CardTransaction from "@/components/CardTransaction.vue";
	import emitter from "@/eventBus.js";
	import EditCategoryExpenses from "./EditCategoryExpenses.vue";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction,
			EditCategoryExpenses
		},

		inject: ["parentValidator"],

		data () {
			return {
				categoryExpenseSelected: {},
				modalEdit: false,
				categoryExpenses: [],
				linhas: [],
				loading: true,

				invalidForm: true,
				categoryExpensesService: new CategoryExpensesService(),

				errMsg: "Nenhuma categoria de transação cadastrada!",
				colunas: [
					"Categoria da Transação",
					"Permite Renda"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 0,
					order: 1,
					query: ""
				},
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 0,
						label: "Categoria da Transação",
						textAlign: "left",
						cols: 9,
						visible: true
					},
					1: {
						idx: 1,
						label: "Permite Renda",
						textAlign: "center",
						cols: 3,
						visible: true
					},
					2: {
						idx: 2,
						label: "",
						textAlign: "center",
						cols: 3,
						visible: false
					},
					3: {
						idx: 3,
						label: "",
						textAlign: "right",
						cols: 3,
						visible: false
					},
					4: {
						idx: 4,
						label: "",
						textAlign: "left",
						cols: 6,
						visible: false
					},
					5: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					},
					6: {
						idx: null,
						label: "",
						textAlign: "left",
						cols: 12,
						visible: false
					},
					7: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					}
				},
				showPaginationOnlyFooter: true
			};
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			this.findCategoryExpenses();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findCategoryExpenses();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findCategoryExpenses();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findCategoryExpenses();
			},

			async findCategoryExpenses () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const result = await this.categoryExpensesService.listCategoryExpenses({offset, limit, sortTable}) || {};
				this.categoryExpenses = result.rows || [];
				this.linhas = result.rows.reduce((acc, gu) => [
					...acc,
					{
						idCategoryExpense: gu.idCategoryExpense,
						cols: [
							gu.description,
							gu.income ? "Sim" : "Não"
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async openEdit (item_) {
				let item = {};
				if (item_.idCategoryExpense)
					[ item ] = this.categoryExpenses.filter(gu => gu.idCategoryExpense === item_.idCategoryExpense);

				this.categoryExpenseSelected = item;
				this.modalEdit = true;
			},

			async confirmaApagar (item_) {
				const [ item ] = this.categoryExpenses.filter((gu) => gu.idCategoryExpense === item_.idCategoryExpense);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover a categoria de transação?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idCategoryExpense);
			},

			async apagar (idCategoryExpense) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.categoryExpensesService.deleteCategoryExpense({idCategoryExpense});
						this.findCategoryExpenses();
						emitter.emit("reloadCategory", { reload: true });

						return {
							title: "Sucesso!",
							body: "Categoria de transação deletada com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar a categoria de transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findCategoryExpenses();
			},

			closeModal () {
				this.modalEdit = false;
			}
		}
	};
</script>

<style scoped>
	.label-center {
		text-align: center;
	}

	.toggle-categoria {
		margin-top: 7px;
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>
